<template>
  <b-card
    no-body
    class="d-flex justify-content-between align-items-right hero"
  >
    <b-row>
      <b-col
        cols="8"
        class="text-sm-left mb-0"
      >
        <span
          class="mb-0 font-weight-bolder mian"
          style="font-size:20px;"
        >Main Breaker
        </span>
      </b-col>
      <b-col
        cols="4"
        class="text-sm-right mt-0"
      >
        <b-button
          id="toggle-btn"
          v-b-modal="'modalMDB'"
          variant="primary"
          style="font-size: 14px;"
          title="Click to show more"
        >
          View<feather-icon
            size="14"
            icon="ChevronsRightIcon"
          />
        </b-button>
      </b-col>
    </b-row>
    <ModalMDB />
    <app-echart-doughnut :series="series" />
  </b-card>
</template>

<script>
import {
  BCard, BCol, BButton, VBPopover, BRow,
  // BCardBody,
  // BImg,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import axios from '@axios'
import AppEchartDoughnut from '@core/components/charts/echart/AppEchartDoughnut.vue'
import ModalMDB from '@/views/StatisModal/ModalMDB.vue'

export default {
  components: {
    BCard,
    // BCardBody,
    // BAvatar,
    // BImg,
    BRow,
    ModalMDB,
    BCol,
    BButton,
    AppEchartDoughnut,
  },
  directives: {
    'b-popover': VBPopover,
    Ripple,
  },
  data() {
    return {
      statisticTitle: '',
      Total: '',
      ON: '',
      OFF: '',
      Trip: '',
      Open: '',
      items: [],
      series: [
        {
          name: 'Main Distribution Board',
          type: 'pie',
          radius: ['50%', '70%'],
          avoidLabelOverlap: false,
          label: {
            show: false,
          },
          labelLine: {
            show: true,
          },
          data: [
            {
              name: 'ON',
              value: '',
              itemStyle: {
                color: '#04FF15',
                barBorderRadius: [5, 5, 0, 0],
              },
              label: {
                show: true,
                position: 'top',
                fontWeight: 'bold',
                fontSize: 14,
                color: '#04FF15',
                formatter(params) {
                  return `ON: ${params.value}`
                },
              },
            },
            {
              name: 'OFF',
              value: '',
              itemStyle: {
                color: '#FA0404',
                barBorderRadius: [5, 5, 0, 0],
              },
              label: {
                show: true,
                position: 'top',
                fontWeight: 'bold',
                fontSize: 14,
                color: '#FA0404',
                formatter(params) {
                  return `OFF: ${params.value}`
                },
              },
            },
            {
              name: 'Trip',
              value: '',
              itemStyle: {
                color: '#FFBD04',
                barBorderRadius: [5, 5, 0, 0],
              },
              label: {
                show: true,
                position: 'top',
                fontWeight: 'bold',
                fontSize: 14,
                color: '#FFBD04',
                formatter(params) {
                  return `TRIP: ${params.value}`
                },
              },
            },
          ],
        },
      ],
    }
  },
  created() {
    setInterval(() => {
      this.getChatBP()
    }, 7000)
  },
  mounted() {
    this.getChatBP()
  },
  methods: {
    getChatBP() {
      axios
        .get('/get_mdb')
        .then(response => {
          response.data.forEach(value => {
            this.series[0].data[0].value = value.ON
            this.series[0].data[1].value = value.OFF
            this.series[0].data[2].value = value.Trip
          })
        })
        .catch(error => {
          console.log(error)
        })
    },
    // dataDryContact() {
    //   axios
    //     .get('/get_mdb')
    //     .then(response => {
    //       this.Total = response.data[0].Total
    //       this.On = response.data[0].On
    //       this.Off = response.data[0].Off
    //       this.Trip = response.data[0].Trip
    //     })
    //     .catch(error => {
    //       console.log(error)
    //     })
    // },
  },
}
</script>
<style scoped>

.hero::before {
      content: "";
      background-image: url('https://www.tpeengineering.com/wp-content/uploads/2020/06/Standard-control-cabinet-Metropolitan-Electricity-Authority.jpg');
      position: absolute;
      background-size: cover;
      top: 0px;
      right: 0px;
      bottom: 0px;
      left: 0px;
      opacity: 0.4;
      border-radius: 20px;
  }

.mian {
  position: relative;
  color: #ffffff;
  font-size: 14rem;
  line-height: 1.8;
  text-align: center;
  padding: 5px;text-align: left; font-size:14px; text-decoration: underline
}
.p {
  position: relative;
  color: #ffffff;
  font-size: 14rem;
  line-height: 0.9;
  padding: 5px;text-align: left; font-size:14px;
}
</style>
